import { NgModule } from '@angular/core';
import { Routes, RouterModule, UrlSegment, UrlSegmentGroup } from '@angular/router';
import { ResolveHostResolver } from '../shared/resolver/resolve-host.resolver';
import { ApplinkConsumeComponent } from './applink-consume/applink-consume.component';
import { CommentCpIFrameComponent } from '../shared/components/comment/comment-cp-service/comment-cp-iframe.component';
import { LinkConsumeComponent } from './link-consume/link-consume.component';
import { PreviewLinkComponent } from '../file/preview-link/preview-link.component';
import { PreviewApplinkComponent } from '../file/preview-applink/preview-applink.component';
import { PreviewLinkLayoutComponent } from '../layout/preview-link-layout/preview-link-layout.component';

export function isSharedLink(url: UrlSegment[], group: UrlSegmentGroup) {
  let fullPath = '';
  group.segments.forEach((el: any) => fullPath = fullPath + '/' + el.path);
  return group.segments.length > 0 && fullPath.includes('dl') && !fullPath.includes('view') ?
    ({
      consumed: url, posParams: {
        cachekey: new UrlSegment(group.segments[1].path, {})
      }
    })
    : null;
}

export function isAppLink(url: UrlSegment[], group: UrlSegmentGroup) {
  let fullPath = '';
  group.segments.forEach((el: any) => fullPath = fullPath + '/' + el.path);
  return group.segments.length > 0 && fullPath.includes('al') && !fullPath.includes('view') ?
    ({
      consumed: url, posParams: {
        cachekey: new UrlSegment(group.segments[1].path, {})
      }
    })
    : null;
}

export function isSharedLinkView(url: UrlSegment[], group: UrlSegmentGroup) {
  let fullPath = '';
  group.segments.forEach((el: any) => fullPath = fullPath + '/' + el.path);
  return group.segments.length > 0 && fullPath.includes('dl') && fullPath.includes('view') ?
    ({
      consumed: url, posParams: {
        cachekey: new UrlSegment(group.segments[1].path, {}),
        type: new UrlSegment(group.segments[3].path, {}),
        id: new UrlSegment(group.segments[4].path, {}),
      }
    })
    : null;
}

export function isAppLinkView(url: UrlSegment[], group: UrlSegmentGroup) {
  let fullPath = '';
  group.segments.forEach((el: any) => fullPath = fullPath + '/' + el.path);
  return group.segments.length > 0 && fullPath.includes('al') && fullPath.includes('view') ?
    ({
      consumed: url, posParams: {
        cachekey: new UrlSegment(group.segments[1].path, {}),
        type: new UrlSegment(group.segments[3].path, {}),
        id: new UrlSegment(group.segments[4].path, {}),
      }
    })
    : null;
}

const routes: Routes = [
  {
    path: 'cm', component: PreviewLinkLayoutComponent,
    children: [{
      path: '', component: CommentCpIFrameComponent
    }]
  },
  {
    path: ':cachekey/:key', component: PreviewLinkLayoutComponent,
    children: [
      { path: '', component: LinkConsumeComponent, resolve: { validLink: ResolveHostResolver } }
    ]
  },
  {
    path: ':cachekey/:key/view/:type/:id', component: PreviewLinkComponent
  },
  {
    matcher: isAppLink, component: PreviewLinkLayoutComponent,
    children: [
      { path: '', component: ApplinkConsumeComponent, resolve: { validLink: ResolveHostResolver } } // for al/:cachekey
    ]
  },
  { matcher: isAppLinkView, component: PreviewApplinkComponent }, // for al/:cachekey/view/:type/:id
  {
    matcher: isSharedLink, component: PreviewLinkLayoutComponent,
    children: [
      { path: '', component: LinkConsumeComponent, resolve: { validLink: ResolveHostResolver } } // for dl/:cachekey
    ]
  },
  { matcher: isSharedLinkView, component: PreviewLinkComponent }, // for dl/:cachekey/view/:type/:id
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LinkConsumeRoutingModule { }
